<template>
  <form class="dashboard-block">
    <h2>Contract Type</h2>
    <div class="panel panel-grey">
      <div class="panel-body">
        <div>
          <selectize
            class="selectize selectize-single"
            name="contract"
            v-model="stateFirstContractId"
            :options="contractOptions">
          </selectize>
          <div class="spacer-y-2" v-if="activeContract && !contractChanged">
            <div class="row">
              <div class="col-md-6 col-sm-12 col-xs-12">
                <label class="control-label">{{ activeContract.name }}</label>
                <p>{{ activeContract.description }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <p>Start:
                  <input
                    v-if="activeContract.pivot !== null && activeContract.pivot.start_date !== null"
                    name="start_date"
                    type="date"
                    class="form-control"
                    placeholder="2025-01-01"
                    v-model="activeContract.pivot.start_date"/>
                  <input
                    v-else
                    name="start_date"
                    type="date"
                    class="form-control"
                    placeholder="2025-01-01"
                    v-model="activeContract.start_date"/>
                </p>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <p>End:
                  <input
                    v-if="activeContract.pivot !== null && activeContract.pivot.end_date !== null"
                    name="end_date"
                    type="date"
                    class="form-control"
                    placeholder="2025-01-01"
                    v-model="activeContract.pivot.end_date"/>
                  <input
                    v-else
                    name="end_date"
                    type="date"
                    class="form-control"
                    placeholder="2025-01-01"
                    v-model="activeContract.end_date"/>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-xs-12">
                <div v-if="user.contracts && user.contracts.length && user.contracts[0].user_requirement_values.length">
                  <h3>Requirements</h3>
                  <span v-for="requirement in user.contracts[0].user_requirement_values" :key="requirement.id">
                {{ requirement.name }}: {{ requirement.value }}{{ requirement.requirement_value ? '/' + requirement.requirement_value : ''}}<br/>
              </span>
                </div>
              </div>
            </div>
          </div>
          <div class="spacer-y-2" v-else-if="contractChanged">
            <p>
              The contract has changed. Please 'save' to update the information.
            </p>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <ladda-button
          type="submit"
          class="btn btn-sm btn-primary"
          :click="handleSaveContract"
          :disabled="userIsAdmin && !canEditAdmin">
          Save
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { stateMapper, helpers } from 'mixins/users'
import { handleServerErrors, notify } from 'utils'
import Selectize from '../ext/codium/CodiumSelectize'

export default {
  mixins: [stateMapper, helpers],
  components: {
    Selectize
  },
  data () {
    return {
      contractOptions: [],
      initialContractId: null,
    }
  },
  created () {
  },
  computed: {
    ...mapState('user', ['user']),
    activeContract () {
      const talentContract = this.user.contracts.find(contract => contract.id === this.stateFirstContractId)
      if (talentContract !== undefined) {
        return talentContract
      }
      return this.contractOptions.find(element => element.id === this.stateFirstContractId)
    },
    contractChanged () {
      return this.stateFirstContractId !== this.initialContractId
    }
  },
  mounted () {
    this.getContracts().then(response => {
      this.contractOptions = response.data.map(item => {
        return {
          text: item.name,
          ...item
        }
      })
      this.initialContractId = this.stateFirstContractId
    })
  },
  methods: {
    ...mapActions('user', ['updateUser', 'setUserProperty']),
    ...mapActions('contract', ['getContracts']),
    handleSaveContract () {
      return this.updateUser({
        id: this.user.id,
        payload: {
          contract_id: this.stateFirstContractId,
          contract_start_date: this.activeContract.pivot !== undefined && this.activeContract.pivot.start_date ? this.activeContract.pivot.start_date : this.activeContract.start_date,
          contract_end_date:  this.activeContract.pivot !== undefined && this.activeContract.pivot.end_date ? this.activeContract.pivot.end_date : this.activeContract.end_date
        }
      })
        .then(response => {
          this.setUserProperty({ property: 'contracts', value: response.data.contracts })
          this.initialContractId = this.stateFirstContractId
          notify.success('Successfully set user contract')
        })
        .catch((error) => {
          if (error.response) {
            handleServerErrors(error, this.errors)
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw error
          }
        })
    }
  }
}
</script>
